module.exports = __webpack_public_path__ + "img/sp.6fde8801.png";